import Service from "./Service";
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export class CourseService extends Service{
    constructor() {
        super();
        this.baseURL = 'course';
    }

    findByCategoryId(categoryId) {
        return fetch(SERVER_URL + this.baseURL + '/findByCategoryId/' + categoryId, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    findBySubcategoryId(subcategoryId) {
        return fetch(SERVER_URL + this.baseURL + '/findBySubcategoryId/' + subcategoryId, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    findByLabelId(labelId) {
        return fetch(SERVER_URL + this.baseURL + '/findByLabelId/' + labelId, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    taughtCourses() {
        return fetch(SERVER_URL + this.baseURL + '/taughtCourses', {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")},
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    getSubscriedCount(id) {
        return fetch(SERVER_URL + this.baseURL + '/getSubscriedCount/' + id, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")},
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    // findAll() {
    //     return fetch('data/courses.json').then(res => res.json()).then(result => result.data);
    // }
}